<lib-top-bar></lib-top-bar>
<div class="app-container">
  <div class="row mx-0">
    <div class="col-12 px-0 mx-auto" [ngClass]="{ 'col-lg-10 mx-auto p-5': !context.isApplicationEmbedded(), 'sku-matching-tool-container': context.onSkuMatchingTool() }">
      <router-outlet></router-outlet>

      <div class="text-center mt-3">
        Product Management v{{versionNumber}} - <span class="logout-link" (click)="logout()">Log Out</span>
        <div hidden>
          <br><small>Environment: {{environment.name}}, Api URL: {{environment.apiUrl}}, Redirect URI: {{environment.redirectUri}}</small>
        </div>       
      </div>

    </div>
  </div>
</div>